import Pill from "@irati/ui/src/Pill"
import {Body} from "@irati/ui/src/Typography"
import styled from "styled-components"
import {PHONE} from "../global/media"

export const Container = styled.div`
  ${({theme}) => `
    display: flex;
    position: relative;
    align-items: center;
    border-radius: ${theme.border.radius.large};
    height: 238px;
    padding: 0 ${theme.spacing.two}
    `}

  ${({theme}) => theme.mediaQueries.minWidthMedia.phoneLandscape`
    padding: 0 ${theme.spacing.five}
  `}
  overflow: hidden;
`

export const BackgroundImg = styled.div<{imgUrl: string}>`
  ${({theme, imgUrl}) => `
    z-index: -1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    background-size: cover;
    filter: brightness(0.4);
    background-repeat: no-repeat;
    background-position: center;
    background-image: linear-gradient(${theme.colors.secondary2}, ${theme.colors.primary2});
    ${imgUrl && `background-image: url("${imgUrl}");`}
  `}
`

export const Content = styled.div<{color: string}>`
  ${({theme, color}) => `
    h1,
    h2,
    h3,
    span,
    ${Body} {
      text-align: left
      color: ${color || theme.colors.utility.white};
    }
    `}
`

export const PromoSection = styled.div`
  display: flex;
  > div:nth-child(2) > span {
    transform: scale(0.8) translate(0, 10%);
  }
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    > div:nth-child(2) > span {
    transform: scale(0.8) translate(0, 25%);
    }
  `}
`

export const Description = styled(Body)<{hasThumbnail: boolean}>`
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: ${({hasThumbnail}) => (hasThumbnail ? "702px" : "810px")};
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;

  @supports not ((display: -webkit-box) and (-webkit-line-clamp: 2)) {
    max-height: 44px;
  }
`

export const Thumbnail = styled.img`
  ${({theme}) => `
    width: 64px;
    height: 64px;
    object-fit: contain;
    margin-right: ${theme.spacing.two};
    border-radius: ${theme.border.radius.large};
    `}
  ${({theme}) => theme.mediaQueries.minWidthMedia.phoneLandscape`
    width: 128px;
    height: 128px;
    margin-right: ${theme.spacing.five};
  `}
`

export const StyledPill = styled(Pill)`
  position: absolute;
  ${({theme}) => `
  top: ${theme.spacing.two}
  right: ${theme.spacing.two}
  `}
  ${({theme}) => theme.mediaQueries.minWidthMedia.phoneLandscape`
  top: ${theme.spacing.four}
  right: ${theme.spacing.five}
  `}
`

export const HeroSliderSettings = {
  dots: true,
  arrows: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 3000,
  responsive: [{breakpoint: PHONE, settings: {arrows: false, draggable: true}}]
}
